import invitationPage from './invitationPage';
import list from './list';
import {combineReducers} from "redux";

export default combineReducers({list, invitationPage});
